module.exports = __webpack_public_path__ + "static/media/microsoft365.0f8918c3.png";